import styled from 'styled-components'

export const StyledLink = styled.a`
  position: relative;
  width: 120px;
  height: 120px;
  flex-shrink: 0;
`
